import InfluencerHome from './views/influencer/Home'
import InfluencerOrders from './views/influencer/Orders'
import InfluencerWallet from './views/influencer/Wallet'
import InfluencerProfile from './views/influencer/Profile'
import InfluencerSettings from './views/influencer/Settings'
import InfluencerBankManagement from './views/influencer/BankManagement'

// Sidebar icons live in components/Sidebar/sidebarIcons.js, keyed by name.
// Kept out of routes.js on purpose: the vendor sidebar picks its section
// headings by array index, so appending there would shift them.
const influencerRoutes = [
  {
    path: '/home',
    name: 'Home',
    component: InfluencerHome,
    layout: '/influencer'
  },
  {
    path: '/orders',
    name: 'Orders',
    component: InfluencerOrders,
    layout: '/influencer'
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: InfluencerWallet,
    layout: '/influencer'
  },
  {
    path: '/profile',
    name: 'Profile',
    component: InfluencerProfile,
    layout: '/influencer'
  },
  {
    path: '/bank',
    name: 'Bank Management',
    component: InfluencerBankManagement,
    layout: '/influencer'
  },
  {
    path: '/settings',
    name: 'Settings',
    component: InfluencerSettings,
    layout: '/influencer'
  }
]

export default influencerRoutes
